let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kBKb2")).then(() => parcelRequire('9c4AY'));